// Session expiry handling. When any authenticated request comes back 401 the
// admin session JWT is expired or invalid, so we log the user out: clear the
// httpOnly cookie *server-side* (the browser can't delete it from JS), then
// hard-redirect to /login. Clearing the cookie first is essential — otherwise
// `middleware.ts` still sees the stale cookie and bounces /login → /dashboard →
// 401 → /login in a loop.

let redirecting = false;

/**
 * Force a logout after an auth failure. Idempotent (guards against the many
 * concurrent 401s a page can produce), and a no-op on the login page so a
 * failed sign-in attempt doesn't trigger a redirect.
 */
export async function forceLogout(reason: "expired" | "invalid" = "expired"): Promise<void> {
  if (typeof window === "undefined" || redirecting) return;
  if (window.location.pathname === "/login") return;
  redirecting = true;
  try {
    // Server clears the cookie via an expiring Set-Cookie; logout needs no auth.
    await fetch("/api/admin/logout", { method: "POST", credentials: "include" });
  } catch {
    /* best effort — the cookie may already be gone (Max-Age elapsed) */
  }
  window.location.assign(`/login?reason=${reason}`);
}
